import styled from "styled-components";
import { CLOUDN_COLORS, COLORS } from "../../../constants/colors";
import Links from "../../atoms/link/Links";
import { LinkDataType } from "../../../constants/types";
import { useEffect, useState } from "react";

const LinkListBox = (props: LinkDataType) => {
  const [elements, setElements] = useState<JSX.Element[]>([]);

  useEffect(() => {
    setElements(
      props.links.map((data, index) => (
        <Links name={data.name} link={data.link} key={index} />
      ))
    );
  }, [props.links]);
  return (
    <Container>
      <Title className="title">
        {props.groupName === "공공기관, 기타 상업 건물(해외)"
          ? "기타"
          : props.groupName}
      </Title>
      <LinkBox className="links">{elements}</LinkBox>
    </Container>
  );
};

export default LinkListBox;

const Container = styled.div`
  width: 20%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-content: space-between;
  justify-content: center;
  flex-wrap: wrap;

  .title:hover ~ .links {
    opacity: 1;
    bottom: 0;
  }
`;

const Title = styled.div`
  width: 80%;
  height: 6%;
  background-color: ${CLOUDN_COLORS.logoSkyBlue};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2vw;
  font-weight: 500;
  color: white;
  border-radius: 0.5vw;
  transition: all 0.5s;
  &:hover {
    box-shadow: 0 0 10px ${COLORS.deepGray};
  }
`;

const LinkBox = styled.div`
  width: 100%;
  height: 93%;
  box-sizing: border-box;
  opacity: 0;
  position: relative;
  bottom: 3%;

  transition: all 0.5s;

  &:hover {
    opacity: 1;
    bottom: 0;
  }
`;
